import React from "react";
import CustomAPinput from "../../../CustomAPInput/customapinput";
import CustomDateRangePicker from "../../../CustomDatepicker/CustomDateRangePicker";
import CustominputRang from "../../../CustomInput/CustominputRang";
import { Grid } from "@mui/material";
import PropTypes from "prop-types";
import CustomSiteCodeInput from "../../../CustomSiteCode/customsitecodeinput";
export default function ConditionAP(props) {
  const { defaultValue } = props;
  const [dateStart, setDatestart] = React.useState("");
  const [dateEnd, setDateend] = React.useState("");
  const [docNoStart, setDocnostart] = React.useState("");
  const [docNoEnd, setDocnoend] = React.useState("");
  const [siteCode, setSiteCode] = React.useState("");
  const [apCode, setApCode] = React.useState("");

  React.useEffect(async () => {
    await props.result({
      dateStart:
        dateStart === ""
          ? typeof defaultValue["dateStart"] !== "undefined"
            ? defaultValue["dateStart"]
            : ""
          : dateStart,
      dateEnd:
        dateEnd === ""
          ? typeof defaultValue["dateEnd"] !== "undefined"
            ? defaultValue["dateEnd"]
            : ""
          : dateEnd,
      docNoStart:
        docNoStart === ""
          ? typeof defaultValue["docNoStart"] !== "undefined"
            ? defaultValue["docNoStart"]
            : ""
          : docNoStart,
      docNoEnd:
        docNoEnd === ""
          ? typeof defaultValue["docNoEnd"] !== "undefined"
            ? defaultValue["docNoEnd"]
            : ""
          : docNoEnd,
      siteCode:
        siteCode === ""
          ? typeof defaultValue["siteCode"] !== "undefined"
            ? defaultValue["siteCode"]
            : ""
          : siteCode,
      apCode:
        apCode === ""
          ? typeof defaultValue["apCode"] !== "undefined"
            ? defaultValue["apCode"]
            : ""
          : apCode,
    });
    // await sessionStorage.setItem("resultConditionAP", JSON.stringify({ dateStart: dateStart, dateEnd: dateEnd, docNoStart: docNoStart, docNoEnd: docNoEnd, siteCode: siteCode, apCode: apCode }))

    return () => {};
  }, [dateStart, dateEnd, docNoStart, docNoEnd, siteCode, apCode]);

  React.useEffect(() => {
    console.log("defaultValue ap ", defaultValue);

    //  setDatestart(defaultValue["dateStart"])
    //props.result(defaultValue)
    // await props.result({ dateStart: dateStart, dateEnd: dateEnd, docNoStart: docNoStart, docNoEnd: docNoEnd, siteCode: siteCode, apCode: apCode })

    return () => {};
  }, [defaultValue]);

  const resInput = (source, e) => {
    if (source === "DocNo") {
      setDocnostart(e.docNoStart);
      setDocnoend(e.docNoEnd);
    } else if (source === "siteCode") {
      setSiteCode(e);
    } else if (source === "apCode") {
      setApCode(e.apCode);
    } else if (source === "DocDate") {
      // console.log("resInput", e);

      // console.log("resInput", moment(e.enddatevalue).format("DD/MM/YYYY"));

      if (typeof e !== "undefined") {
        setDatestart(typeof e.dateStart !== "undefined" ? e.dateStart : "");
        setDateend(typeof e.dateEnd !== "undefined" ? e.dateEnd : "");
      }
    }
  };
  const keyDown = (e) => {
    console.log(e);
  };
  return (
    <Grid container spacing={3}>
      <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
        <CustomDateRangePicker
          label={"วันที่"}
          resData={(e) => resInput("DocDate", e)}
          defaultValue={defaultValue}
        />
      </Grid>
      <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
        <CustominputRang
          label={"เลขที่เอกสาร"}
          resData={(e) => resInput("DocNo", e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
          defaultValue={defaultValue}
        />
      </Grid>
      <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
        <CustomSiteCodeInput
          label={"สาขา"}
          resData={(e) => resInput("siteCode", e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
          defaultValue={defaultValue["siteCode"]}
        />
      </Grid>
      <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
        <CustomAPinput
          label={"เจ้าหนี้"}
          resData={(e) => resInput("apCode", e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
          defaultValue={defaultValue["apCode"]}
        />
      </Grid>
    </Grid>
  );
}

ConditionAP.propTypes = {
  defaultValue: PropTypes.array,
};
